var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 636,
    height: 640,
    viewBox: "0 0 636 640",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M318.068 128L518 245.864L517.867 285.295L318.068 167.284L152.776 265.408L318.068 363.702L318.06 403L118 284.995L118.203 245.863L318.068 128Z",
    fill: "#03C4A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M318.03 520.198L118.044 402.525L118.02 363.315L318.005 480.942L482.763 382.705L318.004 284.869L318.005 245.651L518.007 363.309L518.054 402.507L318.03 520.198Z",
    fill: "#03C4A1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.001 170.005L318.076 19.9621L618.002 170.005L618.009 469.984L318.015 620.023L18.003 469.997L18.001 170.005Z",
    stroke: "#03C4A1",
    strokeWidth: 35
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d56049c78fe6b1407ce017fba397ecdb.svg";
export { ForwardRef as ReactComponent };